var render = function render(){var _vm=this,_c=_vm._self._c;return _c('layout',[_c('template',{slot:"title"},[_c('img',{attrs:{"width":"200","src":"/logo.png","alt":"Teco Milano","title":"Teco Milano"}})]),_vm._v(" "),_vm._t("default"),_vm._v(" "),_c('template',{slot:"footer"},[_vm._v("\n        "+_vm._s(_vm.trans('layout.footer'))+"\n    ")])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }